export default {
    url: '/logs',
    template: '<div class="col00"><ui-view></ui-view></div>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/logs/index.js